// extracted by mini-css-extract-plugin
export var download = "styles-module__download___HOkn1";
export var link = "styles-module__link___v0vdg";
export var phone = "styles-module__phone___rK0By";
export var sendALink = "styles-module__sendALink___D66mC";